import React from 'react';
import { Link } from 'react-router-dom';
import { ArrowRight, CheckCircle2 } from 'lucide-react';
import { prestationsContent, images } from '../data/mock';

const Prestations = () => {
  return (
    <div className="min-h-screen">
      {/* Hero Section */}
      <section className="py-20 bg-secondary">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="max-w-3xl">
            <h1 className="font-heading text-4xl md:text-5xl font-medium text-foreground mb-6">
              {prestationsContent.title}
            </h1>
            <p className="text-lg text-muted-foreground leading-relaxed">
              {prestationsContent.subtitle}
            </p>
          </div>
        </div>
      </section>

      {/* Session Steps Section */}
      <section className="py-24">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground mb-4">
              Comment se passe un RDV ?
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Une séance de Amma assis se déroule en toute simplicité, 
              sans aucune préparation nécessaire de la part du salarié.
            </p>
          </div>
          <div className="grid md:grid-cols-5 gap-6">
            {prestationsContent.sessionSteps.map((step, index) => (
              <div
                key={step.step}
                className="relative p-6 bg-white border border-border card-hover text-center"
              >
                <div className="w-12 h-12 mx-auto mb-4 bg-primary text-white flex items-center justify-center font-medium text-lg">
                  {step.step}
                </div>
                <h3 className="font-heading text-lg font-medium text-foreground mb-2">
                  {step.title}
                </h3>
                <p className="text-sm text-muted-foreground leading-relaxed">
                  {step.description}
                </p>
                {index < prestationsContent.sessionSteps.length - 1 && (
                  <div className="hidden md:block absolute top-1/2 -right-3 transform -translate-y-1/2 z-10">
                    <ArrowRight className="w-5 h-5 text-primary/40" />
                  </div>
                )}
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Image Break */}
      <section className="relative h-[400px]">
        <img
          src={images.therapy}
          alt="Séance de massage"
          className="w-full h-full object-cover"
        />
        <div className="absolute inset-0 bg-primary/10" />
      </section>

      {/* Business Offers Section */}
      <section className="py-24 section-gradient">
        <div className="max-w-7xl mx-auto px-6 lg:px-12">
          <div className="text-center mb-16">
            <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground mb-4">
              Pour les entreprises
            </h2>
            <p className="text-muted-foreground max-w-2xl mx-auto">
              Des formules flexibles pour répondre aux besoins de votre organisation.
            </p>
          </div>
          <div className="grid md:grid-cols-3 gap-8">
            {prestationsContent.businessOffers.map((offer, index) => (
              <div
                key={index}
                className="bg-white p-8 border border-border card-hover flex flex-col"
              >
                <h3 className="font-heading text-2xl font-medium text-foreground mb-4">
                  {offer.title}
                </h3>
                <p className="text-muted-foreground mb-6 leading-relaxed flex-grow">
                  {offer.description}
                </p>
                <ul className="space-y-3 mb-8">
                  {offer.features.map((feature, idx) => (
                    <li key={idx} className="flex items-center gap-3 text-sm text-foreground">
                      <CheckCircle2 className="w-4 h-4 text-primary flex-shrink-0" />
                      {feature}
                    </li>
                  ))}
                </ul>
                <Link to="/contact" className="btn-primary text-center">
                  Demander un devis
                </Link>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* CTA Section - ENHANCED */}
      <section className="py-24">
        <div className="max-w-4xl mx-auto px-6 lg:px-12 text-center">
          <h2 className="font-heading text-3xl md:text-4xl font-medium text-foreground mb-6">
            Une question sur nos prestations ?
          </h2>
          <p className="text-muted-foreground mb-10 max-w-2xl mx-auto leading-relaxed">
            Je me tiens à votre disposition pour échanger sur vos besoins 
            et vous proposer une solution sur mesure.
          </p>
          <div className="flex flex-col sm:flex-row gap-4 justify-center">
            <Link to="/contact" className="btn-primary bg-primary text-white hover:bg-primary/90">
              Demander un devis entreprise
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
            <Link to="/contact" className="btn-primary">
              Me contacter
              <ArrowRight className="w-4 h-4 ml-2" />
            </Link>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Prestations;
